export const formatNumberWithDotAndComma = (value: string): string => {
  const cleanValue = value.replace(/\./g, '').replace(',', ''); // Remove dots and commas
  const number = parseFloat(cleanValue); // Convert cleaned value to a number

  if (isNaN(number)) return ''; // If it's not a number, return empty string

  // Format the number to add dots as thousand separators and comma for decimals
  return number.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
